import Link from '@/compat/link'

export default function NotFound() {
  return (
    <div className="min-h-[50vh] flex items-center justify-center">
      <div className="text-center space-y-4">
        <h2 className="text-xl font-semibold text-text-primary">
          Page not found
        </h2>
        <p className="text-text-muted">
          The page you're looking for doesn't exist.
        </p>
        <Link
          href="/"
          className="inline-block px-4 py-2 bg-brand-primary text-brand-foreground rounded-md hover:opacity-90"
        >
          Go home
        </Link>
      </div>
    </div>
  )
}
